import React, { useState } from "react";

function LogoWithFallback({ src, alt, className = "branding-logo" }) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return <span className="branding-logo-text">{alt}</span>;
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
}

export function BrandingBarTop({ treeName, speciesName, treeIndex, treeCount }) {
  return (
    <div className="branding-bar branding-bar--top">
      <div className="branding-logos">
        <LogoWithFallback src="/img/logos/staedtebau.png" alt="Städtebauförderung" />
        <LogoWithFallback
          src="/img/logos/muenchen-referat.png"
          alt="Landeshauptstadt München – Referat für Stadtplanung und Bauordnung"
        />
      </div>

      <div style={{ display: "flex", alignItems: "baseline" }}>
        <span className="branding-tree-name">{treeName || "Baum"}</span>
        {speciesName && <span className="branding-tree-species">{speciesName}</span>}
        {treeCount > 1 && (
          <span className="tree-counter" style={{ marginLeft: "20px" }}>
            {treeIndex + 1} / {treeCount}
          </span>
        )}
      </div>

      <LogoWithFallback src="/img/treesense-logo.webp" alt="TreeSense" />
    </div>
  );
}

export function BrandingBarBottom({ currentTreeIndex, treeCount, onNext, onPrev, onGoTo }) {
  return (
    <div className="branding-bar branding-bar--bottom">
      <div className="branding-logos">
        <LogoWithFallback
          src="/img/logos/staedtebau-hinweis.png"
          alt="Gefördert im Städtebauförderungsprogramm Sozialer Zusammenhalt"
          className="branding-logo branding-logo--wide"
        />
        <LogoWithFallback
          src="/img/logos/mgs.png"
          alt="Münchner Gesellschaft für Stadterneuerung mbH"
          className="branding-logo"
        />
      </div>

      <div className="slider-controls">
        {treeCount > 1 && (
          <button className="slider-arrow" onClick={onPrev} aria-label="Vorheriger Baum">
            ‹
          </button>
        )}
        <div className="tree-dots">
          {Array.from({ length: treeCount }).map((_, i) => (
            <button
              key={i}
              className={`tree-dot ${i === currentTreeIndex ? "tree-dot--active" : ""}`}
              onClick={() => onGoTo(i)}
              aria-label={`Baum ${i + 1}`}
            />
          ))}
        </div>
        {treeCount > 1 && (
          <button className="slider-arrow" onClick={onNext} aria-label="Nächster Baum">
            ›
          </button>
        )}
      </div>
    </div>
  );
}
